import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { get } from '@helsenorge/framework-utils/hn-proxy-service';
import { mapTidsperioderToFravaerDatoer } from '../../utils/fravaer-utils';
import { getErrorMessage } from '../../utils/service-utils';
export const initialTidsperiodeState = {
    loading: false,
    error: undefined,
    success: false,
};
export const apiGetTidsperiode = createAsyncThunk('tidsperiode/get', async (req) => {
    const qs = {
        ...req,
    };
    return await get('helsetilbud', 'api/v1/TidsperiodeInnbygger', qs);
}, {
    condition: (_args, { getState }) => {
        const state = getState();
        return !state.tidsperiode.loading && !state.tidsperiode.fravaerDatoer;
    },
});
const tidsperiodeSlice = createSlice({
    name: 'tidsperiode',
    initialState: initialTidsperiodeState,
    reducers: {
        RESET: () => initialTidsperiodeState,
    },
    extraReducers: builder => {
        builder
            .addCase(apiGetTidsperiode.pending, state => {
            state.loading = true;
        })
            .addCase(apiGetTidsperiode.fulfilled, (state, action) => {
            state.loading = false;
            state.success = true;
            state.fravaerDatoer = mapTidsperioderToFravaerDatoer(action.payload);
        })
            .addCase(apiGetTidsperiode.rejected, state => {
            state.loading = false;
            state.error = getErrorMessage();
        });
    },
});
export const { RESET } = tidsperiodeSlice.actions;
export default tidsperiodeSlice.reducer;
